var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFormMintPlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_63_6896)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.0191 8.36659L14.329 9.35804L15.1574 9.98398L14.2321 10.4544L12.3737 11.4031L13.0113 11.8424L13.9016 12.4606L12.9374 12.9583L7.02783 16.0064C8.01046 16.5471 9.11383 16.8306 10.2354 16.8306C13.9095 16.8306 16.8879 13.8525 16.8879 10.1782C16.8913 8.62031 16.3447 7.11125 15.3444 5.91699L13.0191 8.36659Z",
    fill: "#171717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.1798 12.1519L5.86986 11.1566L5.04151 10.5307L5.96682 10.0603L7.82521 9.11144L7.18757 8.66837L6.29726 8.05007L7.26148 7.55242L13.486 4.341C12.4318 3.67958 11.2117 3.33043 9.96716 3.33401C6.29309 3.33401 3.3147 6.31214 3.3147 9.98647C3.3147 11.6933 3.9601 13.2523 5.01762 14.4304L7.1798 12.1519Z",
    fill: "#171717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.51218 14.7641C3.33804 13.4772 2.62265 11.7665 2.62265 9.89248C2.62265 5.89959 5.87298 2.64926 9.86586 2.64926C11.3394 2.64926 12.774 3.09637 13.9832 3.93994L14.6286 3.60558C13.307 2.59872 11.6543 2 9.86586 2C5.51531 2 1.97339 5.54192 1.97339 9.89248C1.97339 11.953 2.76655 13.8271 4.06121 15.2343L4.51218 14.7639V14.7641Z",
    fill: "#171717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6475 5.41848C16.7244 6.68207 17.3776 8.32277 17.3776 10.1073C17.3776 14.1002 14.1273 17.3505 10.1344 17.3505C8.78142 17.3505 7.45562 16.9734 6.31257 16.258L5.64771 16.6001C6.96574 17.5138 8.53254 18 10.1344 18C14.4849 18 18.0269 14.4581 18.0269 10.1075C18.0269 8.13617 17.2998 6.32845 16.0985 4.94434L15.6475 5.41868L15.6475 5.41848Z",
    fill: "#171717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.30739 10.6726L8.19692 12.1033L3.92798 16.6017L12.4153 12.2239L10.8835 11.1625L13.71 9.7162L11.8205 8.28541L16.0894 3.79102L7.60211 8.1688L9.13391 9.23043L6.30739 10.6726Z",
    fill: "#23BEE2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_63_6896"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.0534,
    height: 16,
    fill: "white",
    transform: "translate(1.97339 2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormMintPlaceholder);
export default __webpack_public_path__ + "static/media/form-mint-placeholder.1f12cf17bba06195b38ad8fb1f6d6775.svg";
export { ForwardRef as ReactComponent };